import { render, staticRenderFns } from "./AssessmentSettings.vue?vue&type=template&id=bc1541f0"
import script from "./AssessmentSettings.vue?vue&type=script&lang=js"
export * from "./AssessmentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports